'use client';

import Image from 'next/image';
import { ModalSelect } from './_components/select';
import { useState } from 'react';
import { useRouter } from 'next/navigation';

type Option = {
  label: string;
  value: string;
};

// Lista "Para você"
const servicesForYou: Option[] = [
  {
    label: 'CAIXA Alimentação',
    value: 'https://voce.caixaprepagos.com.br/#',
  },
  {
    label: 'CAIXA Refeição',
    value: 'https://voce.caixaprepagos.com.br/?',
  },
  {
    label: 'CAIXA Multi',
    value: 'https://voce.caixaprepagos.com.br/',
  },
  {
    label: 'tagCAIXA',
    value: 'https://minhacontatag.caixaprepagos.com.br/',
  },
];

// Lista "Para sua empresa"
const servicesForBusiness: Option[] = [
  {
    label: 'CAIXA Alimentação',
    value: 'https://empresa.caixaprepagos.com.br/portal/portal-caixa/login/#',
  },
  {
    label: 'CAIXA Refeição',
    value: 'https://empresa.caixaprepagos.com.br/portal/portal-caixa/login/?',
  },
  {
    label: 'CAIXA Multi',
    value: 'https://empresa.caixaprepagos.com.br/portal/portal-caixa/login/',
  },
  {
    label: 'vtCAIXA',
    value: 'https://valetransporte.caixaprepagos.com.br/caixa/login',
  },
  {
    label: 'frotaCAIXA',
    value:
      'https://frota.caixaprepagos.com.br/portalcartaocaixa/login/autenticacaocaixa',
  },
  {
    label: 'tagCAIXA Empresas',
    value: 'https://speseguro.caixaprepagos.com.br/loginCAIXA',
  },
];

interface ModalTwoProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function LoginModal({ isOpen, onClose }: ModalTwoProps) {
  const [selectedHref, setSelectedHref] = useState('');
  const [selectedTab, setSelectedTab] = useState<'you' | 'business'>('you');
  const router = useRouter();

  const currentOptions =
    selectedTab === 'you' ? servicesForYou : servicesForBusiness;

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="relative w-full max-w-2xl rounded-lg p-6">
        {/* Botão de fechar */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 w-10 h-10 rounded-lg bg-white hover:bg-gray-100 shadow-md flex items-center justify-center"
          aria-label="Fechar modal"
        >
          <Image
            src={'/icons/x-circle.png'}
            alt="Close modal"
            height={26}
            width={26}
          />
        </button>

        <div className="bg-white w-full max-w-2xl rounded-lg shadow-lg p-6">
          {/* Título e descrição */}
          <div className="mb-6">
            <h2 className="text-bluecaixa text-xl font-bold">
              Acesse sua área de cliente
            </h2>
            <p className="text-gray-600 mt-2">
              Acompanhe saldos, consulte extratos, gerencie benefícios e tenha
              total controle das suas informações de forma simples, rápida e
              segura.
            </p>
          </div>

          {/* Botões de categoria */}
          <div className="flex justify-start gap-4 mb-6">
            <button
              onClick={() => {
                setSelectedTab('you');
                setSelectedHref('');
              }}
              className={`px-4 py-2 rounded-md flex-1 font-medium border transition ${
                selectedTab === 'you'
                  ? 'bg-bluecaixa text-white'
                  : 'bg-white text-bluecaixa border-bluecaixa'
              }`}
            >
              PARA VOCÊ
            </button>
            <button
              onClick={() => {
                setSelectedTab('business');
                setSelectedHref('');
              }}
              className={`px-4 py-2 rounded-md flex-1 font-medium border transition ${
                selectedTab === 'business'
                  ? 'bg-bluecaixa text-white'
                  : 'bg-white text-bluecaixa border-bluecaixa'
              }`}
            >
              PARA SUA EMPRESA
            </button>
          </div>

          {/* Select */}
          <div className="space-y-4 mb-6">
            <ModalSelect services={currentOptions} onChange={setSelectedHref} />
          </div>

          {/* Botão de continuar */}
          <div className="flex flex-col gap-3 items-end">
            <button
              className="flex items-center justify-center gap-2 bg-orangecaixa hover:bg-orange-400 text-white px-4 py-4 rounded w-full"
              onClick={() => {
                if (selectedHref !== '') {
                  router.push(selectedHref);
                }
              }}
            >
              <Image
                src="/icons/arrow-right-circle.png"
                alt="Seta"
                width={20}
                height={20}
              />
              CONTINUAR
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
